import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable({
  providedIn: 'root'
})
export class TranslatedPaginator implements MatPaginatorIntl {

  itemsPerPageLabel: string;
  lastPageLabel: string;
  nextPageLabel: string;
  previousPageLabel: string;
  firstPageLabel: string;

  readonly changes: Subject<void>;

  constructor(private readonly translateService: TranslateService) {
    marker('pagination.page_1_of_1');
    marker('pagination.first_page');
    marker('pagination.next_page');
    marker('pagination.previous_page');
    marker('pagination.last_page');
    marker('pagination.page_n_of_amount');
    marker('pagination.item_per_page');

    this.firstPageLabel = this.translateService.instant('pagination.first_page');
    this.itemsPerPageLabel = this.translateService.instant('pagination.item_per_page');
    this.lastPageLabel = this.translateService.instant('pagination.last_page');
    this.nextPageLabel = this.translateService.instant('pagination.next_page');
    this.previousPageLabel = this.translateService.instant('pagination.previous_page');

    this.changes = new Subject<void>();
    this.translateService.onLangChange.subscribe(_ => {
      this.changes.next();
    });
  }

  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0) {
      return this.translateService.instant('pagination.page_1_of_1') as string;
    }

    return this.translateService.instant('pagination.page_n_of_amount', { currentPage: page + 1, nbPage: Math.ceil(length / pageSize) }) as string;
  }
}
